import { API_BASE_URL } from "configs/AppConfig"

export const getAttachment = (id) =>{
    return API_BASE_URL + 'v1/file/get/' + id;
}